/* Maison Byōbu · page d'œuvre « Signatures » (sections/mb-sig-oeuvre.liquid, 23/10/2026).
   Le comportement de la maquette validée (Tora v9) : carrousel (flèches, vignettes, barre de progression, clavier),
   comptoir (formats, « Mes dimensions », matières, aperçu glissable du cadrage, récapitulatif), barre collante.
   Le prix et le panier sont ceux du moteur <mb-cadreur> (assets/mb-cadreur.js ; depuis le 24/10, il refuse tout ajout sans
   les champs d'Apippa et désactive son bouton : les boutons d'ici le recopient), piloté comme le fait
   assets/mb-v3-achat.js :
   - dimensions : poserMesures(L, H), ou les champs du moteur puis lire() pour « Mes dimensions » ;
   - matière : la radio du moteur ([data-mb-matieres] input, value = variante) est cochée, l'événement change part ;
   - montants : tarifImprime(L, H, prix au m²) du moteur, promotion comprise (enveloppe d'assets/mb-offre.js) ;
   - cadrage : l'aperçu écrit x0 / y0 du moteur (bornés), comme l'étape « Ajustez votre paysage »
     d'assets/mb-achat-etapes.js : la propriété de ligne _cadrage est donc ce que le client a vu ;
   - achat : la case [data-mb-verif] est cochée (la vérification humaine avant impression la remplace), puis le bouton
     du moteur [data-mb-ajouter] est cliqué (Apippa, propriétés de ligne, formulaire du thème).
   Limite de finesse du fichier : décision du 23/10, une vente n'est jamais bridée par la résolution du fichier. Le moteur
   ne la calcule que s'il connaît la taille du fichier source (srcL, srcH) : elle est remise à zéro ici, après son
   initialisation (aucun bouton « devis », aucun message de limite). Les bornes 50–1 500 × 50–400 cm restent.
   24/10, 15 h (affichage seulement) : la phrase « Votre mur a changé… » reste visible jusqu'au prochain clic ou changement
   (voir « L'achat ») ; L'Autocollant à 370 g/m² au total (fiche publique du fournisseur).
   02/11/2026 (audit, validé par Marcel) : Le Mat Lisse à 190 g/m², le chiffre confirmé (l'épaisseur, non confirmée, est
   retirée) ; la marge de coupe dite partout de la même façon (voir « Marge de coupe », plus bas). */
(() => {
  const d = document;
  const racine = d.querySelector('[data-mb-sig-oeuvre]');
  if (!racine || racine.dataset.sigPret) return;
  racine.dataset.sigPret = 'oui';

  /* Marge de coupe (02/11/2026, audit, validé par Marcel) : une seule règle partout, celle du guide de mesure et du
     dossier de pose, 10 cm à chaque mesure (5 cm de chaque côté), avec l'exemple du guide. sections/mb-sig-oeuvre.liquid
     dit encore « 5 à 10 cm » : corrigé ici, à reporter dans la section à sa prochaine modification. */
  (() => {
    const w = d.createTreeWalker(racine.closest('.shopify-section') || racine, NodeFilter.SHOW_TEXT);
    for (let n = w.nextNode(); n; n = w.nextNode()) {
      if (n.nodeValue.indexOf('5 à 10 cm') < 0) continue;
      n.nodeValue = n.nodeValue.replace('5 à 10 cm à la largeur et à la hauteur pour la coupe.', '10 cm à la largeur et 10 cm à la hauteur pour la coupe. Exemple : pour un mur de 350 × 250 cm, indiquez 360 × 260 cm.').replace('5 à 10 cm à chacune', '10 cm à chacune (5 cm de chaque côté)');
    }
  })();

  const $ = (s) => racine.querySelector(s);
  const $$ = (s) => Array.prototype.slice.call(racine.querySelectorAll(s));
  const NOM = racine.dataset.nom || '';
  let RATIO = parseFloat(racine.dataset.ratio) || 2;
  const DEFAUT = { x: parseFloat(racine.dataset.x) || 0.5, y: parseFloat(racine.dataset.y) || 0.5 };

  const FORMATS = [
    { id: 'tete', nom: 'Tête de lit', l: 200, h: 140 },
    { id: 'mur', nom: 'Un mur', l: 360, h: 250 },
    { id: 'grand', nom: 'Un grand mur', l: 600, h: 270 },
    { id: 'perso', nom: 'Mes dimensions', l: 350, h: 260 },
  ];
  /* Caractéristiques : celles de la maquette (fancywalls.eu, relevé du 22/10 ; Sisal : référentiel du 09/10) */
  const MATIERES = {
    'mat-lisse': { nom: 'Le Mat Lisse', tech: 'Intissé lisse',
      fiche: ['Intissé, papier et fibres textiles · 190 g/m²', 'Finition mate, toucher doux', 'Pose à la colle, pièces sèches', "Fibres certifiées FSC · émissions dans l'air intérieur classées A+ · réaction au feu C-s1, d0", 'Sans PVC'] },
    texture: { nom: 'Le Texturé', tech: 'Intissé texturé, pré-encollé',
      fiche: ['Intissé · 300 g/m² · 0,45 mm', 'Finition mate, fin relief', "Pré-encollé : la colle s'active à l'eau", "Pièces sèches et humidité modérée, salle de bain comprise, hors projection d'eau", 'Sans PVC'] },
    autocollant: { nom: "L'Autocollant", tech: 'Textile adhésif',
      fiche: ['Toile 100 % polyester · 370 g/m² au total · 0,39 mm', 'Finition mate, trame tissée, toucher de tissu', 'Autocollant : sans colle ni eau, repositionnable pendant la pose', "Pièces sèches et humidité modérée, salle de bain comprise, hors projection d'eau", 'Sans PVC'] },
    naturel: { nom: 'Le Texturé Naturel', tech: 'Sisal naturel',
      fiche: ['Fibres végétales de sisal tissées, sur un dos intissé', 'Chaque panneau est unique : les variations font partie de la matière', 'Pose à la colle, de préférence par un artisan', 'Pièces sèches uniquement', 'Entretien au chiffon sec ou à peine humide'] },
  };
  const COMMUN = ['Encres UV certifiées GREENGUARD, conformes à la norme jouets EN 71-3, sans PFAS', "Tenue à la lumière : 8 sur 8 sur l'échelle de la laine bleue", "Repositionnable pendant la pose, se retire d'un seul tenant", 'Entretien au chiffon humide, sans frotter'];

  const etat = { f: 'mur', m: racine.dataset.variante || '', l: 350, h: 260 };
  const eur = (centimes) => {
    const v = centimes / 100;
    const e = Math.abs(v - Math.round(v)) < 0.005;
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: e ? 0 : 2, maximumFractionDigits: e ? 0 : 2 }).format(e ? Math.round(v) : v);
  };
  const m2 = (v) => new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
  const metres = (dd) => `${m2(dd[0] / 100)} × ${m2(dd[1] / 100)} m`;
  const fmt = (id) => FORMATS.filter((x) => x.id === id)[0];
  const dims = (id) => (id === 'perso' ? [etat.l, etat.h] : [fmt(id).l, fmt(id).h]);
  const valide = (dd) => Number.isInteger(dd[0]) && Number.isInteger(dd[1]) && dd[0] >= 50 && dd[0] <= 1500 && dd[1] >= 50 && dd[1] <= 400;
  const centimesDe = (t) => { const n = parseFloat(String(t || '').replace(/[^\d,.-]/g, '').replace(',', '.')); return Number.isFinite(n) ? Math.round(n * 100) : null; };
  const optionsM = $$('#sig-matieres .option');
  const matiere = () => optionsM.filter((b) => b.dataset.m === etat.m)[0] || optionsM.filter((b) => !b.disabled)[0] || optionsM[0];
  const infoM = (b) => (b && MATIERES[b.dataset.cle]) || { nom: (b && b.dataset.nom) || '', tech: (b && b.dataset.nom) || '', fiche: [] };
  const prixM2 = (b) => ((b && parseInt(b.dataset.prix, 10)) || 0) / 100;

  /* ---------- Les montants : toujours ceux du moteur ---------- */
  let c = null;
  const lireTarif = (t, div = 1) => {
    if (!t || t.centimes == null) return null;
    const fin = centimesDe(t.prix);
    if (fin == null) return null;
    const avant = t.barre ? centimesDe(t.barre) : null;
    return { fin: Math.round(fin / div), avant: avant && avant > fin ? Math.round(avant / div) : null };
  };
  /* Le prix d'un mur, à la matière donnée (la taille saisie est la taille imprimée : MB_MARGE = 0 dans le moteur) */
  const tarif = (dd, pm2) => (c && valide(dd) && pm2 ? lireTarif(c.tarifImprime(dd[0], dd[1], pm2)) : null);
  /* Le prix au m² d'une matière : le moteur sur 2 m² (200 × 100 cm), divisé par deux */
  const auM2 = (pm2) => (c && pm2 ? lireTarif(c.tarifImprime(200, 100, pm2), 2) : null);
  const montant = (p, suffixe = '') => {
    if (!p) return '—';
    if (!p.avant) return eur(p.fin) + suffixe;
    return `<s class="prix-barre">${eur(p.avant)}</s> <span class="prix-vert">${eur(p.fin)}${suffixe}</span>`;
  };
  const pret = () => !!(c && c.dataset.etat === 'pret' && c.imp && c.L && c.H);

  /* ---------- Le dessin du comptoir ---------- */
  function rendre() {
    const dd = dims(etat.f);
    const ok = valide(dd);
    const b = matiere();
    const info = infoM(b);
    const pm2 = prixM2(b);
    $$('#sig-formats .option').forEach((x) => x.setAttribute('aria-checked', x.dataset.f === etat.f ? 'true' : 'false'));
    optionsM.forEach((x) => x.setAttribute('aria-checked', x === b ? 'true' : 'false'));
    FORMATS.forEach((f) => {
      const fd = dims(f.id);
      $(`[data-dim="${f.id}"]`).textContent = f.id === 'perso' ? 'Au centimètre près' : metres(fd);
      $(`[data-pf="${f.id}"]`).innerHTML = c ? montant(tarif(fd, pm2)) : '';
    });
    if (c) optionsM.forEach((x) => { x.querySelector('.option__prix').innerHTML = montant(auM2(prixM2(x)), '/m²'); });
    $('#sig-mesures').hidden = etat.f !== 'perso';
    $('#sig-resume-mur').textContent = ok ? metres(dd) : '—';
    $('#sig-resume-matiere').textContent = info.nom;
    $('#sig-recap-desc').textContent = `${NOM} · ${ok ? metres(dd) : '—'} · ${info.nom}${ok && dd[0] * dd[1] < 10000 ? ' (1 m² minimum)' : ''}`;
    /* Le prix de CE mur : la taille imprimée du moteur (this.imp), comme sa ligne au panier */
    const t = c ? (pret() && ok ? lireTarif(c.tarifImprime(c.imp.w, c.imp.h)) : null) : null;
    $('#sig-recap-prix').innerHTML = c ? montant(t) : '&nbsp;';
    $('#sig-recap-klarna').textContent = t ? `ou 3 × ${eur(Math.round(t.fin / 3))} avec Klarna` : ' ';
    $('#sig-barre-txt').innerHTML = `${ok ? metres(dd) : '—'} · ${info.nom}${c ? ` · ${montant(t)}` : ''}`;
    if (c) {
      const depart = optionsM.filter((x) => !x.disabled).map((x) => auM2(prixM2(x))).filter(Boolean).sort((p, q) => p.fin - q.fin)[0];
      if (depart) $('#sig-prix-depart').innerHTML = montant(depart);
    }
    apercu(ok ? dd : null);
    const pm = c ? auM2(pm2) : null;
    $('#sig-fiche').innerHTML = `<p><b>${info.nom}</b> (${info.tech.toLowerCase()}) · ${pm ? montant(pm) : eur(Math.round(pm2 * 100))} le m²</p><ul>${info.fiche.map((x) => `<li>${x}</li>`).join('')}</ul>${
      b && b.dataset.cle === 'naturel' ? '' : `<p style="margin-top:14px"><b>Impression</b></p><ul>${COMMUN.map((x) => `<li>${x}</li>`).join('')}</ul>`}`;
    legende();
  }

  /* L'aperçu du cadrage : le cadre du moteur (fw, fh, x0, y0), sinon le même calcul centré tant qu'il n'est pas prêt */
  function apercu(dd) {
    const cadre = $('#sig-cadre');
    let w; let h; let x; let y;
    if (pret()) {
      w = c.fw; h = c.fh; x = c.borner(c.x0, 1 - c.fw); y = c.borner(c.y0, 1 - c.fh);
    } else {
      const r = dd ? dd[0] / dd[1] : 360 / 250;
      if (r <= RATIO) { h = 1; w = r / RATIO; } else { w = 1; h = RATIO / r; }
      x = Math.min(Math.max(DEFAUT.x - w / 2, 0), 1 - w); y = Math.min(Math.max(DEFAUT.y - h / 2, 0), 1 - h);
    }
    cadre.style.left = `${x * 100}%`; cadre.style.width = `${w * 100}%`;
    cadre.style.top = `${y * 100}%`; cadre.style.height = `${h * 100}%`;
    cadre.setAttribute('data-dim', dd ? metres(dd) : '');
  }

  /* ---------- Le moteur suit chaque choix ---------- */
  const radio = (id) => (c ? c.querySelector(`[data-mb-matieres] input[type="radio"][value="${id}"]`) : null);
  function recopierErreur() {
    const el = $('#sig-erreur');
    const src = c && c.el.erreur;
    const html = src && !src.hidden && etat.f === 'perso' ? src.innerHTML.trim() : '';
    el.innerHTML = html; el.hidden = !html;
  }
  function pousser(signaler) {
    if (!c) return;
    const dd = dims(etat.f);
    if (etat.f === 'perso') {
      c.el.L.value = Number.isInteger(dd[0]) ? String(dd[0]) : '';
      c.el.H.value = Number.isInteger(dd[1]) ? String(dd[1]) : '';
      c.lire(signaler);
    } else c.poserMesures(dd[0], dd[1]);
    const r = radio(etat.m);
    if (r && !r.checked && !r.disabled) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    neutraliserLimite();
    recopierErreur();
  }
  /* Le cadrage : écrit dans le moteur, borné, puis son mur redessiné (même geste que l'étape « Ajustez votre paysage ») */
  function deplacer(x0, y0) {
    if (!pret()) return;
    c.x0 = c.borner(x0, 1 - c.fw);
    c.y0 = c.borner(y0, 1 - c.fh);
    c.fondMur();
  }
  const recentrer = () => { if (pret()) deplacer(c.defaut.x - c.fw / 2, c.defaut.y - c.fh / 2); };
  function neutraliserLimite() {
    if (!c) return;
    if (c.srcL || c.srcH) { c.srcL = 0; c.srcH = 0; }
    if (c.horsLimite) c.afficherPrix();
  }

  $('#sig-formats').addEventListener('click', (e) => {
    const b = e.target.closest('.option'); if (!b) return;
    etat.f = b.dataset.f;
    pousser(etat.f === 'perso');
    if (etat.f !== 'perso') recentrer();
    rendre();
    oublierMurChange();
    if (etat.f === 'perso') $('#sig-largeur').focus();
  });
  $('#sig-matieres').addEventListener('click', (e) => {
    const b = e.target.closest('.option'); if (!b || b.disabled) return;
    etat.m = b.dataset.m;
    pousser(false);
    rendre();
    oublierMurChange();
  });
  [['sig-largeur', 'l'], ['sig-hauteur', 'h']].forEach(([id, cle]) => {
    const champ = $(`#${id}`);
    const lire = (signaler) => { const v = parseInt(champ.value, 10); etat[cle] = Number.isNaN(v) ? NaN : v; pousser(signaler); rendre(); oublierMurChange(); };
    champ.addEventListener('input', () => lire(false));
    champ.addEventListener('change', () => lire(true));
  });

  /* Glisser le cadrage */
  const ap = $('#sig-apercu');
  let glisse = null;
  ap.addEventListener('pointerdown', (e) => {
    if (!pret() || e.button > 0) return;
    glisse = { x: e.clientX, y: e.clientY, x0: c.x0, y0: c.y0, id: e.pointerId };
    ap.setPointerCapture(e.pointerId);
  });
  ap.addEventListener('pointermove', (e) => {
    if (!glisse || e.pointerId !== glisse.id) return;
    const r = ap.getBoundingClientRect();
    deplacer(glisse.x0 + (e.clientX - glisse.x) / r.width, glisse.y0 + (e.clientY - glisse.y) / r.height);
    apercu(valide(dims(etat.f)) ? dims(etat.f) : null);
  });
  const lacher = () => { if (!glisse) return; glisse = null; if (c && typeof c.majVoirChezMoi === 'function') c.majVoirChezMoi(); oublierMurChange(); };
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((t) => ap.addEventListener(t, lacher));

  /* ---------- Carrousel ---------- */
  const piste = $('#sig-piste');
  const vues = $$('.vue');
  let courant = 0;
  $('#sig-vignettes').innerHTML = vues.map((v, i) => {
    const src = v.dataset.vignette;
    const dedans = src ? `<img src="${src}" alt="" loading="lazy">` : `<span>${v.dataset.titre}</span>`;
    return `<button type="button" data-i="${i}" aria-label="${v.dataset.titre}">${dedans}</button>`;
  }).join('');
  function aller(i) { i = Math.max(0, Math.min(vues.length - 1, i)); piste.scrollTo({ left: i * piste.clientWidth }); }
  function legende() {
    const p = $('#sig-progres');
    p.style.width = `${100 / Math.max(1, vues.length)}%`; p.style.transform = `translateX(${courant * 100}%)`;
    $$('#sig-vignettes button').forEach((b) => b.setAttribute('aria-current', +b.dataset.i === courant ? 'true' : 'false'));
  }
  let tempo;
  piste.addEventListener('scroll', () => { clearTimeout(tempo); tempo = setTimeout(() => { courant = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth)); legende(); }, 50); }, { passive: true });
  $('#sig-vignettes').addEventListener('click', (e) => { const b = e.target.closest('button'); if (b) aller(+b.dataset.i); });
  $('#sig-prec').addEventListener('click', () => aller(courant - 1));
  $('#sig-suiv').addEventListener('click', () => aller(courant + 1));
  piste.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); aller(courant + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); aller(courant - 1); } });

  /* ---------- Barre collante (téléphone) ---------- */
  const barre = $('#sig-barre');
  const cta = $('#sig-cta');
  if ('IntersectionObserver' in window) new IntersectionObserver((es) => {
    const e = es[0]; const on = !e.isIntersecting && e.boundingClientRect.top < 0;
    barre.classList.toggle('on', on); barre.setAttribute('aria-hidden', on ? 'false' : 'true'); barre.querySelector('button').tabIndex = on ? 0 : -1;
  }).observe(cta);

  /* ---------- Message court (la maquette) ---------- */
  const toast = $('#sig-toast');
  let tt;
  const dire = (texte) => { toast.textContent = texte; toast.classList.add('on'); clearTimeout(tt); tt = setTimeout(() => toast.classList.remove('on'), 2600); };

  /* ---------- L'achat : un bouton, le moteur fait le reste ---------- */
  const message = $('#sig-message');
  /* 24/10, 15 h (affichage seulement : ni le calcul, ni l'ajout, ni les champs envoyés ne changent). Le moteur écrit
     « Votre mur a changé… » quand le mur change pendant le calcul du prix. Mais quand Apippa arrive après son attente
     (clic plus de 15 s après l'ouverture de la page, Apippa plus long que 3 s), le moteur passe d'abord par
     « Le calcul du prix ne s'est pas chargé… », puis efface ce message dès qu'Apippa arrive : la fiche, qui recopie son
     message, ne montrait plus rien (et « — » pour un mur non valide). Ici : la configuration du moteur est notée au clic ;
     à la fin de l'essai (le bouton du moteur n'est plus « en cours »), sans ajout, si elle a changé, la phrase est gardée.
     Elle s'affiche quand le moteur n'a pas d'autre message, jusqu'au prochain clic ou changement de format, de matière
     ou de dimensions. */
  const MUR_CHANGE = 'Votre mur a changé pendant le calcul du prix. Vérifiez-le, puis ajoutez-le au panier.';
  let essai = null;
  let murChange = false;
  function recopierMessage() {
    if (!c) return;
    const tmp = d.createElement('div');
    tmp.innerHTML = c.el.message ? c.el.message.innerHTML : '';
    tmp.querySelectorAll('[data-mb-autre]').forEach((x) => x.remove());
    const html = tmp.innerHTML.trim() || (murChange ? MUR_CHANGE : '');
    message.innerHTML = html; message.hidden = !html;
    if (html && c.el.message.dataset.type === 'ok') dire('Votre mur est dans votre panier.');
  }
  function oublierMurChange() {
    if (!murChange) return;
    murChange = false;
    recopierMessage();
  }
  function finEssai() {
    const vue = essai;
    essai = null;
    if (!c || vue === null || typeof c.configuration !== 'function' || c.el.message.dataset.type === 'ok') return;
    if (c.configuration() !== vue) { murChange = true; recopierMessage(); }
  }
  function ajouter() {
    if (!c) { message.textContent = 'Le calcul du prix se charge, un instant.'; message.hidden = false; return; }
    oublierMurChange();
    pousser(true);
    const v = c.valider();
    if (!v.ok) {
      if (etat.f !== 'perso') { etat.f = 'perso'; rendre(); }
      const el = $('#sig-erreur'); el.innerHTML = v.texte; el.hidden = false;
      $(v.champ === c.el.H ? '#sig-hauteur' : '#sig-largeur').focus();
      return;
    }
    neutraliserLimite();
    if (!c.el.verif.checked) { c.el.verif.checked = true; c.el.verif.dispatchEvent(new Event('change', { bubbles: true })); }
    essai = typeof c.configuration === 'function' ? c.configuration() : null; // lecture seule : le mur vu au clic
    c.el.bouton.click();
  }
  racine.addEventListener('click', (e) => {
    const b = e.target.closest('[data-action="panier"]');
    if (b) { e.preventDefault(); ajouter(); }
  });

  /* ---------- Le montage sur le moteur, une fois tous les scripts différés passés ---------- */
  function monter(el) {
    if (c) return;
    c = el;
    if (c.a > 0) {
      RATIO = c.a;
      ap.style.aspectRatio = String(RATIO);
    }
    const salle = d.getElementById('cadrer');
    if (salle) salle.setAttribute('aria-hidden', 'true');
    neutraliserLimite();
    const r0 = optionsM.filter((x) => { const r = radio(x.dataset.m); return r && r.checked; })[0];
    if (!etat.m && r0) etat.m = r0.dataset.m;
    pousser(false);
    recentrer();
    /* Ce que le moteur répond est recopié : en cours, message (ajouté, erreur ; recopierMessage, plus haut) */
    let occupe = false;
    const recopierBouton = () => {
      const busy = c.el.bouton.getAttribute('aria-busy') === 'true';
      const bloque = c.el.bouton.disabled; // 24/10 : Apippa absent, le moteur bloque l'ajout (sa phrase arrive par le message)
      $$('[data-action="panier"]').forEach((b) => {
        b.disabled = busy || bloque;
        if (busy) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
        b.textContent = busy ? 'Ajout en cours…' : 'Ajouter au panier';
      });
      if (occupe && !busy) finEssai(); // 24/10, 15 h : fin d'un essai d'ajout
      occupe = busy;
    };
    new MutationObserver(recopierBouton).observe(c.el.bouton, { attributes: true, attributeFilter: ['aria-busy', 'disabled'] });
    if (c.el.message) new MutationObserver(recopierMessage).observe(c.el.message, { childList: true, subtree: true, characterData: true, attributes: true });
    recopierBouton(); recopierMessage();
    if (c.el.erreur) new MutationObserver(recopierErreur).observe(c.el.erreur, { childList: true, subtree: true, attributes: true });
    c.addEventListener('mb-cadreur:prix', () => setTimeout(() => { neutraliserLimite(); rendre(); }, 0));
    rendre();
    racine.dataset.moteur = 'oui';
  }
  let essais = 0;
  const attendre = () => {
    const el = d.querySelector('mb-cadreur');
    if (el && el.el && el.el.prix && typeof el.tarifImprime === 'function') monter(el);
    else if (essais++ < 100) setTimeout(attendre, 100);
  };
  const demarrer = () => { if ('customElements' in window) customElements.whenDefined('mb-cadreur').then(() => setTimeout(attendre, 0)); };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', demarrer); else demarrer();

  /* L'en-tête collant du thème : la galerie collante (ordinateur) se place dessous (hauteur de la partie collante) */
  const entete = () => {
    const h = d.querySelector('#header-group');
    let bas = 0;
    if (h) for (const s of h.children) { const cs = getComputedStyle(s); if (cs.position === 'sticky' || cs.position === 'fixed') bas = Math.max(bas, (parseFloat(cs.top) || 0) + s.getBoundingClientRect().height); }
    racine.style.setProperty('--mb-sig-entete', `${Math.max(0, Math.round(bas))}px`);
  };
  entete();
  window.addEventListener('resize', entete, { passive: true });
  window.addEventListener('load', entete);

  rendre();
})();
